// services/emailSupportApi.js
import axios from "axios";
import * as actionType from "../../constant/actionType";

export const EmailSupport = async (user, form_data) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    let formdata = new FormData();
    for (let key in form_data) {
      if (key === "support_email_attach") {
        if (form_data[key]) {
          formdata.append(`support_email_attach`, form_data[key]);
        }
      } else {
        formdata.append(key, form_data[key]);
      }
    }

    const response = await axios({
      method: "post",
      data: formdata,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/${user}/SupportEmailSend`,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};